import { Gauge } from "components/DesignSystem/Gauge/Gauge";

type CompanyRecordsCardProps = {
  completeness: number;
};

export const CompanyRecordsCard = ({
  completeness,
}: CompanyRecordsCardProps) => {
  return (
    <div className="t-flex t-items-center t-justify-between t-gap-7 t-rounded-2xl t-border t-border-solid t-border-neutral-10 t-bg-surface t-p-8 sm:t-flex-col sm:t-items-start sm:t-gap-4 sm:t-p-4">
      <div className="t-flex-1">
        <div className="t-text-subtitle-lg t-text-text-60">
          Entity Setup Progress
        </div>
        <p className="t-mt-1.5 t-text-body t-text-neutral-50 t-mb-0">
          Shows how much of your company profile we have on file. A higher
          percentage means more accurate books and filings prepared on time.
        </p>
      </div>
      <Gauge
        value={completeness}
        label="Complete"
        className="t-w-[160px] sm:t-self-center"
      />
    </div>
  );
};
